import React from 'react';
import { useCanCreatePoll, useMessageComposer } from '../../MessageInput';
import { useMessageInputContext, useTranslationContext } from '../../../context';
export const PollCreationDialogControls = ({ close, }) => {
    const { t } = useTranslationContext('PollCreationDialogControls');
    const { handleSubmit: handleSubmitMessage } = useMessageInputContext();
    const messageComposer = useMessageComposer();
    const canCreatePoll = useCanCreatePoll();
    return (React.createElement("div", { className: 'str-chat__dialog__controls' },
        React.createElement("button", { className: 'str-chat__dialog__controls-button str-chat__dialog__controls-button--cancel', onClick: () => {
                messageComposer.pollComposer.initState();
                close();
            }, type: 'button' }, t('Cancel')),
        React.createElement("button", { className: 'str-chat__dialog__controls-button str-chat__dialog__controls-button--submit', disabled: !canCreatePoll, onClick: () => {
                messageComposer
                    .createPoll()
                    .then(() => handleSubmitMessage())
                    .then(close)
                    .catch(console.error);
            }, type: 'submit' }, t('Create'))));
};
